import React, {useContext, useEffect} from 'react';
import {AppContext} from "../../utils/AppContext";
import {enums} from "../../utils/enums";
import {useNavigate} from "react-router-dom";
import {hydrateUserData} from "../../utils/sharedFunctions";
import Lottie from 'react-lottie';
import walletLoading from '../../assets/lotties/loading.json'
import LoadingScreen from "../../shared-components/loading/LoadingScreen";

const IndexPage = () => {
    const {state: {currentUser, event}, dispatch} = useContext(AppContext);
    const navigate = useNavigate()

    useEffect(() => {
        const getUserData = async () => {
            await hydrateUserData(dispatch, navigate)
        }
        if (!currentUser) getUserData()

        if (currentUser) {
            switch (currentUser?.role) {
                case enums.VALIDATOR:
                    navigate('/ticketScanner')
                    break
                case enums.BARTENDER:
                    navigate('/stand')
                    break
                case enums.BANKER:
                    navigate('/addCash')
                    break
                case enums.WALLET:
                    navigate('/wallet')
                    break
                case enums.GOD:
                    navigate('/god')
                    break
                case enums.ADMIN:
                    navigate('/admin')
                    break
                default:
                    navigate('/')
            }
        }
    }, [currentUser, event])


    return (
       <LoadingScreen/>
    );
};

export default IndexPage;
